import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Chip,
  Paper,
  FormControlLabel,
  IconButton,
  Avatar,
  Tooltip,
  Switch,Input
} from "@material-ui/core";
import {
  CircularProgress,
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  CheckCircle,
  Block,
  AccountCircle,
  Close,
  Edit,
  Delete,
  SubdirectoryArrowLeftOutlined,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";
import { useRoles, useOrganizations } from "../hooks/use_hooks";

import MUIDataTable from "mui-datatables";
import MaskedInput from "react-text-mask";

import { makeStyles } from "@material-ui/styles";
import { AdminService, Validator ,ReportingService} from "../../../utils/web_config";
import { useSnackbar } from "notistack";

import { Autocomplete } from "@material-ui/lab";
const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));




function InvetoryCustomers(props) {
  const classes = useStyles();
  const history = useHistory();

  const [accountData, setAccountData] = useState({});
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    getCustomers(accountData.token);
    // getUsers(accountData.token, accountData.organization?.organization_id);
  }, []);


  const [customers,setCustomers]=useState({
      data:[],
      saving:false,
      loading:false,
      open:false
  });

  const [status,setStatus]=useState("");


  const getCustomers = (token) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));

    setCustomers({ ...customers, loading: true });

    console.log("getting customers .....");

    usersInstance
      .get(new ReportingService().GET_ALL_CUSTOMERS)
      .then(function (response) {
        setCustomers({ ...customers, loading: false });

        const d = response.data;

        if (d.data.content.length == 0) {
          setStatus("There are no customers available.");
        } else {
        //   var usrs = [];

        //   d.data.forEach((u, i) => {
        //     const newUser = u;
        //     newUser["status2"] = u.user_status;
        //     newUser["user_name"] = u.user_first_name + " " + u.user_last_name;

        //     usrs.push(u);
        //   });

          setCustomers({
            ...customers,
            data: d.data.content,
          });

        }
      })
      .catch(function (error) {
        setCustomers({ ...customers, loading: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setStatus(e);

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
        
      });
  };


  const columns = [
    {
      name: "id",
      label: "id",
      options: {
        filter: false,
        sort: false,
        display: 'excluded',
      },
    },
    {
      name: "admin_msid",
      label: "admin id",
      options: {
        filter: false,
        sort: true,
        display: false
      },
    },
    {
      name: "customer_type",
      label: "Customer Type",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "full_names",
      label: "Full names",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "phone_number",
      label: "Phone Number",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
        name: "email",
        label: "email",
        options: {
          filter: false,
          sort: false,
        },
    },
    {
        name: "id_card",
        label: "ID Card",
        options: {
          filter: false,
          sort: false,
        },
    },
    {
        name: "location",
        label: "Location",
        options: {
          filter: false,
          sort: false,
        },
    }
  ];

  const options = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "single",
    searchPlaceholder: "Search user...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: status,
      },
    },
    // customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    //   <CustomUsersToolbar
    //     selectedRows={selectedRows}
    //     displayData={displayData}
    //     setSelectedRows={setSelectedRows}
    //     toggleUser={toggleUser}
    //     openEdit={showUserEdit}
    //     toggling={users.toggling}
    //   />
    // ),
  };

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };
  ///////////////////////////////////


  const [email,setEmail]=useState({value:"",error:""});
  const [idcard,setIdcard]=useState({value:"",error:""});
  const [fullNames,setFullNames]=useState({value:"",error:""});
  const [phoneNumber,setPhoneNumber]=useState({value:"",error:""});
  const [location,setLocation]=useState({value:"",error:""});

  const record_customer=()=>{
      if(email.value==""){
          setEmail({value:"",error:"Enter email"});
      }else if(idcard.value==""){
          setIdcard({value:"",error:"Enter ID card"});
      }else if(fullNames.value==""){
          setFullNames({value:"",error:"Enter full names"});
      }else if(phoneNumber.value==""){
          setPhoneNumber({value:"",error:"Enter phone number"});
      }else if(location.value==""){
          setLocation({value:"",error:"Enter location"});
      }else{
        record_customer_one();
      }
  }


  const record_customer_one=()=>{

    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setCustomers({ ...customers, saving: true });

    let data={
        email: email.value,
        full_names: fullNames.value,
        id_card: idcard.value,
        location: location.value,
        phone_number: phoneNumber.value
      };

    console.log("record customer cummuter .....");

    createInstance
      .post(new ReportingService().RECORD_CUSTOMER, data)
      .then(function (response) {

        console.log("response",response.data);

        var obj=response.data.data;
        var objs=customers.data;
        objs.push(obj);
        
        setCustomers({ ...customers, saving: false,open:false,data:objs});
        
        setEmail({value:"",error:""});
        setIdcard({value:"",error:""});
        setFullNames({value:"",error:""});
        setPhoneNumber({value:"",error:""});
        setLocation({value:"",error:""});
        
    //   get_supply_items(accountData.token);

        notify("success", response.data.message);

      })
      .catch(function (error) {
        setCustomers({ ...customers, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });

  }



  return (
    <div className={classes.root}>
      {/* Dialogs starts for creating new customer */}

      
      <Dialog
        open={customers.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth='sm'
        fullWidth
        onClose={()=>setCustomers({...customers,open:false})}
      >
        <DialogTitle id="alert-dialog-title">{"New Customer"}</DialogTitle>
        <DialogContent>
        

          <Box mt={2}>
          <TextField
                  required
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={fullNames.value}
                  placeholder={"Full Names"}
                  label={"Full Names"}
                  fullWidth
                  onChange={(e)=>{
                      setFullNames({value:e.target.value,error:""});
                  }}
                  helperText={fullNames.error}
                  error={fullNames.error !== ""}
                />
          </Box>

          <Box mt={2}>
          <TextField
                  required
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={email.value}
                  placeholder={"Email"}
                  label={"Email"}
                  fullWidth
                  onChange={(e)=>{
                      setEmail({value:e.target.value,error:""});
                  }}
                  helperText={email.error}
                  error={email.error !== ""}
                />
          </Box>

          <Box mt={2}>
          <TextField
                  required
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={idcard.value}
                  placeholder={"ID Card"}
                  label={"ID Card"}
                  fullWidth
                  onChange={(e)=>{
                     setIdcard({value:e.target.value,error:""}); 
                  }}
                  helperText={idcard.error}
                  error={idcard.error !== ""}
                />
          </Box>

          <Box mt={2}>
          <TextField
                  required
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={location.value}
                  placeholder={"Location"}
                  label={"Location"}
                  fullWidth
                  onChange={(e)=>{
                      setLocation({value:e.target.value,error:""});
                  }}
                  helperText={location.error}
                  error={location.error !== ""}
                />
          </Box>

          <Box mt={2}>
          <TextField
                  required
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={phoneNumber.value}
                  placeholder={"Phone Number"}
                  label={"Phone Number"}
                  fullWidth
                  onChange={(e)=>{
                    setPhoneNumber({value:e.target.value,error:""});  
                  }}
                  helperText={phoneNumber.error}
                  error={phoneNumber.error !== ""}
                />
          </Box>


        </DialogContent>
        <DialogActions>
          <Button 
           variant='outlined'
          onClick={() => {
            setCustomers({...customers,open:false})
          }} color="primary">
            Cancel
          </Button>
          <Button 
          variant='contained'
          disableElevation
          disabled={customers.saving}
          onClick={() => {
            record_customer();
          }} color="primary" autoFocus>
            {customers.saving ? <CircularProgress size={23} /> : "Save"}
          </Button>
        </DialogActions>
      </Dialog>


      {/* Dialogs ends for creating new customer */}

      <Box display="flex">
        <Box mr={2}>
          {" "}
          <AccountCircle color="primary" fontSize="large" />
        </Box>
        <Typography variant="h5" className={classes.title}>
          <b>Invetory Customers</b>
        </Typography>

        <Button onClick={()=>{
            setCustomers({...customers,open:true});

        }} variant="contained" color="primary" disableElevation>
            <Typography>New Customer</Typography>
        </Button>
        
      </Box>
      <Box mt={3} />

      {customers.loading && <LinearProgress />}
      <MUIDataTable
        title={"List of Customers"}
        data={customers.data}
        columns={columns}
        options={options}
      />
    </div>
  );
}

// function CustomUsersToolbar(props) {
//   const { toggleUser, displayData, selectedRows, openEdit } = props;

//   var check = displayData[selectedRows?.data[0]?.index].data[5] == "ENABLED";

//   return (
//     <Box display="flex" alignItems="center">
//       <FormControlLabel
//         control={
//           <Switch
//             disabled={props.toggling}
//             checked={check}
//             // onChange={() => {
//             //   toggleUser(displayData[selectedRows?.data[0]?.index]?.data[0]);
//             // }}
//             value="vertical"
//             color="primary"
//           />
//         }
//         label={check ? "Deactivate user" : "Activate user"}
//       />

//       <Button
//         color="primary"
//         variant="outlined"
//         size="small"
//         startIcon={<Edit />}
//         // onClick={() =>
//         //   openEdit(displayData[selectedRows?.data[0]?.index]?.data[0])
//         // }
//       >
//         Edit
//       </Button>

//       <Box mr={2} ml={2}>
//         <Button
//           color="primary"
//           variant="outlined"
//           size="small"
//           startIcon={<Delete />}
       
//         >
//           Suspend
//         </Button>
//       </Box>
//     </Box>
//   );
// }
export default withLocalize(InvetoryCustomers);
